import { useState } from 'react';
import { DashboardPage } from '../../components/PremiumDesign';
import { Button } from '@/components';
import { CRMDashboardMetrics } from '../components/CRMDashboardMetrics';
import { SalesCategoryChart } from '../components/SalesCategoryChart';
import { SocialTrafficTable } from '../components/SocialTrafficTable';
import { RecentOrdersTable } from '../components/RecentOrdersTable';
import { RecentTasksTable } from '../components/RecentTasksTable';
import { RecentFollowUpsTable } from '../components/RecentFollowUpsTable';

const DASHBOARD_TABS = [
  { id: 'leads', label: 'Leads' },
  { id: 'tasks', label: 'Tasks' },
  { id: 'follow_ups', label: 'Follow-ups' },
];

export function CRMDashboardPage() {
  const [activeTab, setActiveTab] = useState('leads');

  return (
    <DashboardPage className="!bg-transparent !p-0 !h-full min-h-0">
      <div className="crm-dashboard w-full flex flex-col gap-4 pb-4">
        <CRMDashboardMetrics />

        {/* Pipeline + Lead Sources: strict 50/50 split on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
          <SalesCategoryChart />
          <SocialTrafficTable />
        </div>

        {/* Tab switcher bar: Leads | Tasks | Follow-ups rendered as buttons matching View all button font */}
        <div className="flex items-center gap-2 shrink-0 mb-1">
          {DASHBOARD_TABS.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <Button
                key={tab.id}
                variant={isActive ? 'primary' : 'secondary'}
                onClick={() => setActiveTab(tab.id)}
                className={`h-9 px-4 sm:px-5 font-sf-pro-display font-semibold text-sm sm:text-[15px] cursor-pointer focus:outline-none focus-visible:outline-none focus:ring-0 outline-none select-none ${
                  !isActive
                    ? '!bg-white !text-[#1F2241] !border-[#EBF4EA] hover:!bg-gray-50'
                    : ''
                }`}
              >
                {tab.label}
              </Button>
            );
          })}
        </div>

        {/* Dynamic Table based on active tab */}
        <div className="w-full">
          {activeTab === 'leads' && <RecentOrdersTable />}
          {activeTab === 'tasks' && <RecentTasksTable />}
          {activeTab === 'follow_ups' && <RecentFollowUpsTable />}
        </div>
      </div>
    </DashboardPage>
  );
}
